(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cxd-landing"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cxd-landing')) {
    customElements.define('cxd-landing', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();

        const options = {
          signal: this.controller.signal
        };

        const arena = this.querySelector('.cxd-landing-arena');
        const logo = this.querySelector('.cxd-landing-butterfly');
        const button = this.querySelector('button');
        const reduced = matchMedia('(prefers-reduced-motion: reduce)');

        let x = 20;
        let y = 20;
        let dx = 1;
        let dy = 0.72;
        let maxX = 0;
        let maxY = 0;
        let previous = 0;
        let paused = false;
        let hovered = false;
        let focused = false;

        const draw = () => {
          logo.style.transform = `translate3d(${x}px, ${y}px, 0)`;
        };

        const measure = () => {
          maxX = Math.max(0, arena.clientWidth - logo.offsetWidth);
          maxY = Math.max(0, arena.clientHeight - logo.offsetHeight);

          x = Math.min(x, maxX);
          y = Math.min(y, maxY);

          draw();
        };

        this.observer = new ResizeObserver(measure);
        this.observer.observe(arena);
        this.observer.observe(logo);

        measure();

        button.hidden = false;

        button.addEventListener('click', () => {
          paused = !paused;

          button.textContent = paused
            ? button.dataset.resume
            : button.dataset.pause;

          button.setAttribute('aria-pressed', String(paused));
        }, options);

        logo.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') hovered = true;
        }, options);

        logo.addEventListener('pointerleave', () => {
          hovered = false;
        }, options);

        logo.addEventListener('focus', () => {
          focused = true;
        }, options);

        logo.addEventListener('blur', () => {
          focused = false;
        }, options);

        const frame = now => {
          const dt = previous
            ? Math.min((now - previous) / 1000, 0.05)
            : 0;

          previous = now;

          if (
            !paused &&
            !hovered &&
            !focused &&
            !reduced.matches &&
            !document.hidden
          ) {
            const speed = Number(this.dataset.speed) *
              (this.clientWidth < 600 ? 0.75 : 1);

            x += dx * speed * dt;
            y += dy * speed * dt;

            if (x <= 0 || x >= maxX) {
              x = Math.max(0, Math.min(x, maxX));
              dx *= -1;
            }

            if (y <= 0 || y >= maxY) {
              y = Math.max(0, Math.min(y, maxY));
              dy *= -1;
            }

            draw();
          }

          this.animation = requestAnimationFrame(frame);
        };

        this.animation = requestAnimationFrame(frame);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.animation);
        this.observer?.disconnect();
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cxd-shared-header"]) return;
  try {
    
  if (!window.cxdJoinFamMenuBound) {
    window.cxdJoinFamMenuBound = true;

    document.addEventListener('click', function(event) {
      const link = event.target.closest('[data-cxh-join-fam]');
      if (!link) return;

      const store = document.querySelector('cxd-store');

      if (store) {
        const signupTrigger = store.querySelector('[data-cxs-open]');

        if (signupTrigger) {
          event.preventDefault();

          const menu = link.closest('.cxh-menu');
          if (menu) menu.open = false;

          signupTrigger.click();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cxd-store"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cxd-store')) {
    customElements.define('cxd-store', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();

        const options = { signal: this.abort.signal };
        const arena = this.querySelector('.cxs-arena');
        const mover = this.querySelector('.cxs-bouncer');
        const pause = this.querySelector('[data-cxs-pause]');
        const panel = this.querySelector('.cxs-panel');
        const menu = document.querySelector('.cxh-menu');

        const reduced = matchMedia('(prefers-reduced-motion: reduce)');
        const dialog = document.createElement('dialog');
        let opener = null;

        if (typeof dialog.showModal === 'function') {
          dialog.className = 'cxs-dialog';
          dialog.setAttribute('aria-labelledby', panel.id + '-title');

          this.append(dialog);
          dialog.append(panel);

          panel.querySelector('[data-cxs-close]').hidden = false;

          const openSignup = link => {
            opener = link || null;

            if (menu) menu.open = false;
            if (!dialog.open) dialog.showModal();
          };

          const bindSignupLink = link => {
            if (!link || link.dataset.cxsBound === 'true') return;

            link.dataset.cxsBound = 'true';
            link.addEventListener('click', event => {
              event.preventDefault();
              openSignup(link);
            }, options);
          };

          this.querySelectorAll('[data-cxs-open]').forEach(bindSignupLink);

          panel.querySelector('[data-cxs-close]').addEventListener(
            'click',
            () => dialog.close(),
            options
          );

          dialog.addEventListener('close', () => {
            opener?.focus();

            if (location.hash === '#cxd-signup') {
              history.replaceState(
                history.state,
                '',
                location.pathname + location.search
              );
            }
          }, options);

          const openFromHash = () => {
            if (location.hash !== '#cxd-signup') return;

            if (menu) menu.open = false;
            if (!dialog.open) dialog.showModal();
          };

          window.addEventListener('hashchange', openFromHash, options);
          openFromHash();

        }

        let x = 20;
        let y = 20;
        let maxX = 0;
        let maxY = 0;
        let dx = 1;
        let dy = .72;
        let previous = 0;
        let paused = false;
        let hovered = false;
        let focused = false;

        const draw = () => {
          mover.style.transform = `translate3d(${x}px,${y}px,0)`;
        };

        const measure = () => {
          maxX = Math.max(0, arena.clientWidth - mover.offsetWidth);
          maxY = Math.max(0, arena.clientHeight - mover.offsetHeight);

          x = Math.min(x, maxX);
          y = Math.min(y, maxY);

          draw();
        };

        this.observer = new ResizeObserver(measure);
        this.observer.observe(arena);
        this.observer.observe(mover);

        measure();

        x = maxX * .78;
        y = maxY * .85;

        draw();

        pause.hidden = false;

        pause.addEventListener('click', () => {
          paused = !paused;

          pause.textContent = paused
            ? pause.dataset.resume
            : pause.dataset.pause;

          pause.setAttribute('aria-pressed', String(paused));
        }, options);

        mover.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') hovered = true;
        }, options);

        mover.addEventListener('pointerleave', () => {
          hovered = false;
        }, options);

        mover.addEventListener('focus', () => {
          focused = true;
        }, options);

        mover.addEventListener('blur', () => {
          focused = false;
        }, options);

        const frame = now => {
          const dt = previous
            ? Math.min((now - previous) / 1000, .05)
            : 0;

          previous = now;

          if (
            !paused &&
            !hovered &&
            !focused &&
            !reduced.matches &&
            !document.hidden &&
            !dialog.open &&
            !menu?.open
          ) {
            const speed = Number(this.dataset.speed)
              * (this.clientWidth < 600 ? .75 : 1);

            x += dx * speed * dt;
            y += dy * speed * dt;

            if (x <= 0 || x >= maxX) {
              x = Math.max(0, Math.min(x, maxX));
              dx *= -1;
            }

            if (y <= 0 || y >= maxY) {
              y = Math.max(0, Math.min(y, maxY));
              dy *= -1;
            }

            draw();
          }

          this.frame = requestAnimationFrame(frame);
        };

        this.frame = requestAnimationFrame(frame);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
        this.abort?.abort();

        const dialog = this.querySelector('.cxs-dialog');

        if (dialog) {
          dialog.close();

          const panel = dialog.querySelector('.cxs-panel');

          if (panel) this.append(panel);

          dialog.remove();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
